import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolygonTool = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.25 6C5.25 5.58579 5.58579 5.25 6 5.25H18C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.35752 18.4999 6.65661 18.165 6.73179C18.2123 6.92083 18.1864 7.12805 18.0763 7.30714L14.9642 12.3641C15.9056 13.189 16.5 14.4001 16.5 15.75C16.5 18.2353 14.4853 20.25 12 20.25C9.51473 20.25 7.5 18.2353 7.5 15.75C7.5 13.2647 9.51473 11.25 12 11.25C12.5967 11.25 13.1662 11.3661 13.6873 11.5771L16.6578 6.75H6C5.58579 6.75 5.25 6.41421 5.25 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.875 6C19.875 4.96447 19.0355 4.125 18 4.125C16.9645 4.125 16.125 4.96447 16.125 6C16.125 7.03553 16.9645 7.875 18 7.875C19.0355 7.875 19.875 7.03553 19.875 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.875 6C7.875 4.96447 7.03553 4.125 6 4.125C4.96447 4.125 4.125 4.96447 4.125 6C4.125 7.03553 4.96447 7.875 6 7.875C7.03553 7.875 7.875 7.03553 7.875 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.3598 13.2348C11.25 13.3447 11.25 13.5215 11.25 13.875V15H10.125C9.77145 15 9.59468 15 9.4848 15.1098C9.375 15.2197 9.375 15.3965 9.375 15.75C9.375 16.1035 9.375 16.2803 9.4848 16.3902C9.59468 16.5 9.77145 16.5 10.125 16.5H11.25V17.625C11.25 17.9785 11.25 18.1553 11.3598 18.2652C11.4697 18.375 11.6465 18.375 12 18.375C12.3535 18.375 12.5303 18.375 12.6402 18.2652C12.75 18.1553 12.75 17.9785 12.75 17.625V16.5H13.875C14.2285 16.5 14.4053 16.5 14.5152 16.3902C14.625 16.2803 14.625 16.1035 14.625 15.75C14.625 15.3965 14.625 15.2197 14.5152 15.1098C14.4053 15 14.2285 15 13.875 15H12.75V13.875C12.75 13.5215 12.75 13.3447 12.6402 13.2348C12.5303 13.125 12.3535 13.125 12 13.125C11.6465 13.125 11.4697 13.125 11.3598 13.2348Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgPolygonTool);
export { ForwardRef as ReactComponent };
